<template>
    <div class="his-data">
        <div class="page-header">
            <page-header></page-header>
            <div class="option-select">

                <div class="charts-input">
                    <el-button type="primary" :loading='loading.table' @click="loadHisData()">
                        {{loading.table ? '正在加载' : '刷新数据'}}
                    </el-button>
                </div>
            </div>
        </div>

        <el-row>
            <el-col :span="24">
                <el-card v-if='chartsData.material' class="box-card  css-margin-top">
                    <div class="clearfix chars-header">
                        <span class="card-header-title">产量图表</span>
                    </div>
                    <loading v-show="loading.chart"></loading>
                    <div v-show="!loading.chart">
                        <div v-if='!chartsData' class="img-no-data">
                            <img :src="img_no_data" alt="暂无数据">
                            <p>暂无数据</p>
                        </div>
                        <div v-else ref="charts"></div>
                    </div>
                </el-card>
                <el-card class="box-card  css-margin-top no-padding">
                    <div slot="header" class="clearfix chars-header">
                        <span class="card-header-title">产量报表</span>
                        <div>
                        </div>
                    </div>
                    <div style="padding:0;position:relative">
                        <div v-if="loading.table">
                            <loading></loading>
                        </div>
                        <div class="table-responsive" ref="hisTable" v-else>
                            <table v-if='hisData.data&&hisData.data.monData' class="table table-responsive">
                                <thead>
                                <tr>
                                    <th></th><th>当前月</th><th v-for="mon in 12" :key="mon">{{mon}}月</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr  v-if="deviceInfo.category==='配煤'" >
                                    <td>煤料</td>
                                    <td  v-for="item in hisData.data.monData">
                                        {{item.煤料}}
                                    </td>
                                </tr>
                                <tr>
                                    <td>原料</td>
                                    <td v-for="item in hisData.data.monData">
                                        {{item.原料}}
                                    </td>
                                </tr>
                                  <tr  v-if="deviceInfo.category==='配水'" >
                                    <td>加水</td>
                                    <td v-for="item in hisData.data.monData">
                                        {{item.加水}}
                                    </td>
                                </tr>

                                </tbody>
                            </table>
                            <div style='line-height:40px' v-else>
                                暂无数据
                            </div>

                        </div>
                        <div class="arrow" v-if="isMobile&&hisData.data&&hisData.data.monData">
                            <img style="transform:rotate(180deg)" @touchstart="setScroll('left')" :src="img_arrow"
                                 alt="">
                            <img @touchstart="setScroll('right')" :src="img_arrow" alt="">
                        </div>
                    </div>
                </el-card>

            </el-col>
        </el-row>
    </div>
</template>
<script>
const echarts = require("echarts");
import { mapState } from "vuex";
import Lib from "../../lib/lib.js";
import img_no_data from "../../assets/images/no_data.svg";
import img_arrow from "../../assets/images/arrow.png";

import pageHeader from "../../components/tempControl/header";
import loading from "../../components/common/loading";

export default {
  name: "historyData",
  components: {
    pageHeader,
    loading
  },
  data() {
    return {
      img_no_data,
      img_arrow,
      option: {
        sys_alias: 1,
        dateType: "date"
      },
      sys_alias: [],
      loading: {
        chart: true,
        table: true
      },
      // echarts实例
      charts: "",

      hisData: {
        timeType: "by_day",
        data: [],
        average: []
      },
      chartsData: {
        xData: [],
        proData: [],
        passData: []
      },
      tableHeader: []
    };
  },
  created() {
    this.loadHisData();
  },
  mounted() {
    Lib.M.selectInputFoc();
  },


  computed: mapState({
    isMobile: state => state.isMobile,
    userInfo: state => state.userInfo,
    deviceInfo: state => state.deviceInfo,
    siderbarOpen(state) {
      setTimeout(() => {
        this.charts.resize();
      }, 400);
      return state.siderbarOpen;
    }
  }),

  methods: {
    momentYear(data) {
      return moment(data).format("YYYY-MM");
    },

    /**
             * 用户修改时间，时间类型，窑号
             * @argument type 修改option类型
             */
    changeOption(type) {
      this.loadHisData();
    },
    loadHisData() {
      this.loading.table = true;
      let params = {
        device_id: this.deviceInfo.device_id,
        data_type: "clData",
        sys_alias: this.option.sys_alias
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }

      Lib.api.loadDeviceData(params, data => {
        this.loading.chart = false;
        this.loading.table = false;
        if (data.status_code === "SUCCEEDED") {
          console.log(data.payload);

          if (data.payload && data.payload) {
            try {
              // 整理表格数据
              this.hisData.data = JSON.parse(data.payload.data);
              // 整理图表数据
              this.chartsDataFn(this.hisData.data.monData);
              this.$nextTick(() => {
                this.initChart();
              });
            } catch (error) {
              console.error({
                msg: "产量数据解析错误",
                data: data,
                error: error
              });
            }
          } else {
            this.hisData.data = [];
          }
        } else {
          this.$message(data.msg);
        }
      });
    },
    // 导出
    // exportExcelFn() {
    //     let params = {
    //         device_id: this.deviceInfo.device_id,
    //         data_type: "proData",
    //         sys_alias: this.option.sys_alias,
    //         date: moment(this.option.date).format("YYYY-MM-DD"),
    //         time_type: this.hisData.timeType
    //     };
    //     if (this.userInfo.identity === "USER") {
    //         params.auth_token = this.userInfo.token;
    //     } else {
    //         params.customer_token = this.userInfo.token;
    //     }

    //     let url = `${Lib.C.APIhost}/devices/${this.deviceInfo
    //         .device_id}/pro_export?device_id=${this.deviceInfo
    //         .device_id}&data_type=proData&sys_alias=${this.option
    //         .sys_alias}&date=${moment(this.option.date).format(
    //         "YYYY-MM-DD"
    //     )}&time_type=${this.hisData.timeType}&auth_token=${params.auth_token
    //         ? params.auth_token
    //         : ""}${params.customer_token ?('&customer_token='+ customer_token) : ""}`;
    //     window.open(url);
    // },

    /**
             * 处理生成图表数据
             * @arg data 产量数据
             */
    chartsDataFn(data) {
      // this.chartsData = data
      let coal = [],
        material = [];

      for (let i = 1; i < data.length; i++) {
        coal.push(data[i].煤料);
        material.push(data[i].原料);
      }

       let data1 = [],
        data2 = [];

    //   for (var i = 0; i < 12; i++) {
    //     data1.push(Math.floor((Math.random() + 1) * 100));
    //     data2.push(Math.floor((Math.random() + 2) * 100));
    //   }
    //   console.log(this.deviceInfo.device_sn.search('3002'))
    //   if(this.deviceInfo.device_sn.match('3001')!==-1){
    //       this.chartsData={
    //            coal:data1,
    //          material:data2
    //       }
    //   }else{
    this.chartsData = {
        coal,
        material
      };
    //   }


    },

    initChart() {
      let chartsData = this.chartsData;
      let charts;


      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#283b56"
            }
          }
        },
        legend: {
          data: ["煤料", "原料"],
          align: "left",
          bottom: 20
        },

        xAxis: {
          show: true,
          data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          silent: false,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          show: "true",
          type: "value",
          name: "T"
        },
        series: [
          {
            name: "煤料",
            type: "bar",
            data: chartsData.coal,
            animationDelay: function(idx) {
              return idx * 10;
            },
            itemStyle: {
              normal: {
                color: "#000"
              },
              emphasis: {
                color: "#ccc"
              }
            },
            barCategoryGap: "40%"
          },
          {
            name: "原料",
            type: "bar",
            data: chartsData.material,
            animationDelay: function(idx) {
              return idx * 10;
            },
            itemStyle: {
              normal: {
                color: "#ff8283"
              },
              emphasis: {
                color: "#ff5653"
              }
            },
            barCategoryGap: "40%"
          }
        ],
        animationEasing: "elasticOut",
        animationDelayUpdate: function(idx) {
          return idx * 5;
        }
      };
      if (this.$refs.charts) {
        charts = echarts.init(this.$refs.charts, charts, {
          height: 400
        });
        charts.setOption(option);
      }

      this.charts = charts;
    },
    setScroll(type) {
      let hisTable = this.$refs.hisTable,
        scrollLeft = this.$refs.hisTable.scrollLeft;
      if (type === "right") {
        hisTable.scrollLeft = scrollLeft + 80;
      } else {
        hisTable.scrollLeft = scrollLeft - 80;
      }
    }
  }
};
</script>

<style scoped>
.chars-header {
  font-size: 0.22rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header-title > span {
  font-size: 0.12rem;
}

.his-data-option {
  display: flex;
  justify-content: space-between;
}

.his-data-option .el-select {
  width: 140px;
}

.his-data-option > div:nth-child(2) {
  text-align: center;
}

.his-data-option > * {
  flex: 1;
}

.table-responsive {
  position: relative;
}

.arrow {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  height: 25px;
  justify-content: space-between;
}

@media screen and (max-width: 900px) {
  .his-data-option {
    flex-direction: column;
  }

  .his-data-option > div:nth-child(2) {
    text-align: left;
    margin-top: 20px;
    width: 40%;
  }

  .table > thead > tr > th {
    vertical-align: bottom;
    border-bottom: 2px solid #ddd;
    width: 100px;
  }
}
</style>
<style>
.his_data th,
td {
  font-size: 0.18rem;
}

.his_data .table-time {
  font-size: 0.1rem;
}
</style>




// WEBPACK FOOTER //
// outputData.vue?7145fa83